import { render, staticRenderFns } from "./Usersummary.vue?vue&type=template&id=004bcfe9&scoped=true&"
import script from "./Usersummary.vue?vue&type=script&lang=js&"
export * from "./Usersummary.vue?vue&type=script&lang=js&"
import style0 from "./Usersummary.vue?vue&type=style&index=0&id=004bcfe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004bcfe9",
  null
  
)

export default component.exports